import React, { useState } from 'react';
import styled from 'styled-components';
import { StaticImage } from 'gatsby-plugin-image';
const CompanyLogo = styled.header`
    .header-wrapper {
      background-color: #2F5BEA;
    }

    .header {
      display: flex;
      margin: 0 17.5%;
      padding: 2% 0;
      justify-content: left;
      gap: 20px;
    }

    .company {
      display: flex;
      align-items: center;
      color: white;
      font-weight: bold;
      font-size: 34px;
    }
  `;

export default function Header(){

  return <CompanyLogo id="logo" className="logobar">
    <div className="header-wrapper">
      <div className="header">
        <div className="logo">
          <StaticImage
            src="../../images/bx/bxs-network-chart.png"
            alt="Awesome Logo"
            layout="fixed"
            placeholder="none"
          />
        </div>
        <div className="company">
          Awesome Company
        </div>
      </div>
    </div>
  </CompanyLogo>;
}
